import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { ProductCategory } from '../../app/models/ProductCategory';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-product-categories',
  templateUrl: 'product-categories.html',
})
export class ProductCategoriesPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('productCategoryModal')
  private productCategoryModal: ModalDirective;

  @ViewChild('productCategoryForm')
  private productCategoryForm: NgForm;

  private pageName: string = 'page-product-categories';
  private navControllerService: NavControllerService;
  private productCategories: ProductCategory[] = [];
  private currentCategory = new ProductCategory();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private backendService: PaytronBackendService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getProductCategories();
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  private getProductCategories() {
    this.backendService.getProductCategories().subscribe(
      (categories) => {
        this.productCategories = categories;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addProductCategory() {
    this.currentCategory = new ProductCategory();
    this.productCategoryForm.resetForm();
    this.showProductCategoryModal();
  }

  editProductCategory(category: ProductCategory) {
    this.currentCategory = category;
    this.showProductCategoryModal();
  }

  submitProductCategory(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateProductCategory(this.currentCategory)
      .subscribe(
        (category) => {
          this.getProductCategories();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeProductCategoryModal();
      });
  }

  deleteProductCategory() {
    this.backendService
      .deleteProductCategory(this.currentCategory)
      .subscribe(
        (data) => {
          this.getProductCategories();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  showConfirmModal(category) {
    this.currentCategory = category;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showProductCategoryModal() {
    this.productCategoryModal.show();
  }

  closeProductCategoryModal() {
    this.productCategoryModal.hide();
  }

  showProductsPage() {
    this.navControllerService.showProductsPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/product-categories/product-categories.ts